import BackspaceCommand from './backspace';
import ReturnCommand from './return';
import Command from './command';
import CommandResult from './command-result';
export default Command.extend({
  processZeroWidth() {
    return this._insertBlocks();
  },
  processSingleBlock() {
    this._doBackspace();
    this.snapshotState();
    return this._insertBlocks();
  },
  processMultiBlock() {
    this._doBackspace();
    this.snapshotState();
    return this._insertBlocks();
  },
  _insertBlocks() {
    let blocks = this.get('options.blocks');
    if (blocks.get('length') === 0) {
      return CommandResult.create({
        shouldRerender: false,
        insertedBlocks: blocks
      });
    }
    let mutationResult;
    let selectedBlock = this.get('firstSelectedBlock');
    if (selectedBlock.get('isListType') && blocks.get('length') === 1 && blocks.get('firstObject.isParagraph')) {
      return this._singleTextBlockIntoList(blocks);
    }
    if (selectedBlock.get('isListType') && blocks.get('length') === 1 && blocks.get('firstObject.isListType')) {
      return this._singleListIntoList(blocks);
    }
    if (selectedBlock.get('isListType')) {
      return this._multiBlockIntoLists(blocks);
    }
    if (selectedBlock.get('isCodeBlock') && this.areAllText(blocks)) {
      return this._textIntoCode(blocks);
    }
    if (blocks.get('length') > 1 || blocks.get('firstObject.type') !== 'paragraph') {
      return this._multiBlockOrNotParagraph(blocks);
    }
    if (selectedBlock.get('isNotEditable')) {
      selectedBlock = this.insertDefaultBlock();
      this.setSelectionToStartOf(selectedBlock);
    }
    mutationResult = selectedBlock.insert(blocks.get('lastObject'), this.get('selection.endPositionIndex'));
    this.setSelectionToPositionIndex(mutationResult.get('blockRange.startPoint.positionIndex'));
    return CommandResult.create({
      shouldRerender: true,
      insertedBlocks: blocks
    });
  },
  areAllText(block) {
    return block.every(function (block) {
      return block.get('isTextType');
    });
  },
  _singleTextBlockIntoList(blocks) {
    this._delegateToFirstSelectedBlock(blocks);
    return CommandResult.create({
      shouldRerender: true,
      insertedBlocks: blocks
    });
  },
  _singleListIntoList(blocks) {
    let mutationResult = this.get('firstSelectedBlock').insert(blocks.pop(), this.get('firstSelectedBlockItemSelection'));
    this.setSelectionToItemAndPositionIndex(mutationResult.get('blockRange.startPoint.itemIndex'), mutationResult.get('blockRange.startPoint.positionIndex'));
    return CommandResult.create({
      shouldRerender: true,
      insertedBlocks: blocks
    });
  },
  _multiBlockIntoLists(blocks) {
    let newBlock = this.get('firstSelectedBlock').split(this.get('firstSelectedBlockItemSelection'));
    if (newBlock.get('isNotEmpty')) {
      this.insertBlock(newBlock);
    }
    this.insertBlocks(blocks, this.get('selection.startBlockIndex') + 1);
    if (this.get('firstSelectedBlock.isEmpty')) {
      this.removeFirstSelectedBlock();
    }
    this.setSelectionToEndOf(blocks.get('lastObject'));
    return CommandResult.create({
      shouldRerender: true,
      insertedBlocks: blocks
    });
  },
  _multiBlockOrNotParagraph(blocks) {
    let selectedBlock = this.get('firstSelectedBlock');
    if (selectedBlock.get('canSplit') && !selectedBlock.get('isEmpty')) {
      this._doReturn();
    } else {
      this.removeBlock(selectedBlock);
    }
    this.insertBlocks(blocks, this.get('selection.startBlockIndex'));
    this.setSelectionToEndOf(blocks.get('lastObject'));
    return CommandResult.create({
      shouldRerender: true,
      insertedBlocks: blocks
    });
  },
  _textIntoCode(blocks) {
    let selectedBlock = this.get('firstSelectedBlock');
    let text = blocks.mapBy('text').join('\n\n');
    let lastBlock = blocks.get('lastObject');
    lastBlock.set('text', text);
    let mutationResult = selectedBlock.insert(lastBlock, this.get('selection.endPositionIndex'));
    this.setSelectionToPositionIndex(mutationResult.get('blockRange.startPoint.positionIndex'));
    return CommandResult.create({
      shouldRerender: true,
      insertedBlocks: blocks
    });
  },
  _doBackspace() {
    return BackspaceCommand.create({
      blockList: this.get('blockList'),
      selection: this.get('selection'),
      config: this.get('config')
    }).run();
  },
  _doReturn() {
    return ReturnCommand.create({
      blockList: this.get('blockList'),
      selection: this.get('selection'),
      options: {
        forceSplit: true
      },
      config: this.get('config')
    }).run();
  },
  _delegateToFirstSelectedBlock(blocks) {
    let blockList, selection;
    blockList = this.get('firstSelectedBlock.blockList');
    selection = this.get('firstSelectedBlockItemSelection');
    selection.set('blockList', blockList);
    this.constructor.create({
      blockList,
      selection,
      options: this.get('options'),
      config: this.get('config')
    }).run();
    let newPositionIndex = this.get('selection.startPositionIndex') + blocks.get('lastObject.text.length');
    this.setSelectionToPositionIndex(newPositionIndex);
    return CommandResult.create({
      shouldRerender: true,
      insertedBlocks: blocks
    });
  }
});